import i18n, { ResourceLanguage } from 'i18next'
import type { Locale } from 'date-fns'
import { fi, enGB, sv } from 'date-fns/locale'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import fiTranslations from './translations/fi.json'
import enTranslations from './translations/en.json'
import svTranslations from './translations/sv.json'

/** ISO 639-1 language code */
export enum Language {
  Finnish = 'fi',
  English = 'en',
  Swedish = 'sv',
}

export const formatLanguage: Record<Language, string> = {
  [Language.Finnish]: 'Suomi',
  [Language.English]: 'English',
  [Language.Swedish]: 'Svenska',
}

const dateLocales: Record<Language, Locale> = {
  [Language.Finnish]: fi,
  [Language.English]: enGB,
  [Language.Swedish]: sv,
}

const resources: Record<Language, ResourceLanguage> = {
  [Language.Finnish]: fiTranslations,
  [Language.English]: enTranslations,
  [Language.Swedish]: svTranslations,
}

export function getDateLocale(language?: string): Locale {
  return dateLocales[(language ?? i18n.language) as Language]
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: Object.values(Language),
    fallbackLng: Language.English,
    interpolation: {
      escapeValue: false,
    },
  })

const { t } = i18n

export { i18n, t }
